import React from "react";

const Pagination = ({
  itemsCount,
  pageSize,
  currentPage,
  onPageChange,
  navigation
}) => {
  if (!itemsCount || !pageSize) return null;
  if (pageSize < 1 || pageSize >= itemsCount) return null;

  const pageCount = Math.ceil(itemsCount / pageSize);

  let firstPage = currentPage - pageSize > 1 ? currentPage - pageSize : 1;
  let previousPage = 1;
  let nextPage = pageCount > 1 ? 2 : 1;
  let lastPage = currentPage + pageSize < pageCount ? currentPage + pageSize : pageCount;
  
  let pageStart = Math.trunc((currentPage - 1) / pageSize) * pageSize + 1;
  let pageEnd = pageStart + pageSize - 1 <= lastPage ? pageStart + pageSize - 1 : lastPage;

  switch (navigation) {
    case 'one':
      previousPage = currentPage > 1 ? currentPage - 1 : 1;
      nextPage = currentPage < pageCount ? currentPage + 1 : pageCount;
      break;
    case 'pageSize':
      previousPage = Math.max(currentPage - pageSize, 1);
      nextPage = Math.min(currentPage + pageSize, pageCount);
      break;
    case 'firstAndLast':
      previousPage = Math.max(currentPage - pageSize, 1);
      nextPage = Math.min(currentPage + pageSize, pageCount);
      break;
    default:
      //scroll
      firstPage = 1;
      previousPage = currentPage > 1 ? currentPage - 1 : 1;
      nextPage = currentPage + 1 <= pageCount ? currentPage + 1 : pageCount;
      lastPage = pageCount;

      const halfSize = Math.trunc(pageSize / 2);

      if (currentPage <= halfSize + 1) {
        pageStart = 1;
        pageEnd = Math.min(pageStart + pageSize - 1, pageCount);
      }
      else {
        pageStart = currentPage - halfSize;
        pageEnd = pageStart + pageSize - 1;

        if (pageCount - currentPage < halfSize) {
          pageStart = Math.max(1, pageCount - pageSize + 1);
          pageEnd = pageCount;
        }
        else {
          if (pageEnd > pageCount) {
            pageEnd = pageCount;
            pageStart = Math.max(1, pageCount - pageSize);
          }
        }
      }
      break;
  }

  let pages = [];

  let index = 0;
  for (let i = pageStart; i <= pageEnd; i++) {
    pages[index] = i;
    index++;
  }

  if (pageCount <= pageSize)
    return (
      <nav>
        <ul className="pagination">
          {pages.map(page => (
            <li
              key={page}
              className={
                page === currentPage ? "page-item active" : "page-item"
              }>
              <span
                onClick={() => onPageChange(page)}
                className="page-link">
                {page}
              </span>
            </li>
          ))}
        </ul>
      </nav>
    );
  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
            <span
              className="page-link text-center"
              style={{ cursor: "pointer", minWidth: "44px" }}
              onClick={() => onPageChange(firstPage)}>
              <i className="fas fa-angle-double-left"></i>
            </span>
          </li>
          <li className="page-item">
            <span
              className="page-link text-center"
              style={{ cursor: "pointer", minWidth: "44px" }}
              onClick={() => onPageChange(previousPage)}>
              <i className="fas fa-angle-left"></i>
            </span>
          </li>
        {pages.map(page => (
          <li
            key={page}
            className={page === currentPage ? "page-item active" : "page-item"}>
            <span
              onClick={() => onPageChange(page)}
              className="page-link">
              {page}
            </span>
          </li>
        ))}
          <li className="page-item">
            <span
              className="page-link text-center"
              style={{ cursor: "pointer", minWidth: "44px" }}
              onClick={() => onPageChange(nextPage)}>
              <i className="fas fa-angle-right"></i>
            </span>
          </li>
        <li className="page-item">
            <span
              className="page-link text-center"
              style={{ cursor: "pointer", minWidth: "44px" }}
              onClick={() => onPageChange(lastPage)}>
              <i className="fas fa-angle-double-right"></i>
            </span>
          </li>
      </ul>
    </nav>
  );
};

export default Pagination;
